export enum ApiResponse {
  SUCCESS = "Success",
}
